import { mode, StyleFunctionProps } from '@chakra-ui/theme-tools'

import { brandFocusStyles } from './shared'

const variants = {
  outline: (props: StyleFunctionProps) => ({
    borderRadius: 'lg',
    bg: mode('white', 'gray.800')(props),
    padding: '0.75rem',
    _hover: { borderColor: mode('gray.300', 'gray.600')(props) },
    ...brandFocusStyles(props),
  }),
}

export default {
  variants,
}
